import React from 'react';

function NotFound() {
    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-6 text-center">
                        <div className="mb-4">
                            <div 
                                className="rounded-circle bg-secondary d-inline-flex align-items-center justify-content-center mb-3"
                                style={{ width: '120px', height: '120px' }}
                            >
                                <i className="bi bi-exclamation-triangle text-white" style={{ fontSize: '4rem' }}></i>
                            </div>
                        </div>
                        
                        <h1 className="display-1 fw-bold text-primary">404</h1>
                        <h3 className="mb-3">Página no encontrada</h3>
                        <p className="text-muted mb-4">
                            Lo sentimos, la página que estás buscando no existe o ha sido movida.
                        </p>

                        <div className="d-grid gap-2 d-md-block">
                            <button 
                                className="btn btn-primary px-5 py-2 rounded-pill"
                                onClick={() => window.location.href = '/'}
                            >
                                <i className="bi bi-house me-2"></i>
                                Ir al inicio
                            </button>
                        </div>
                        
                        <div className="mt-4">
                            <small className="text-muted">
                                ¿Tienes un link de acceso? Verifica que esté completo e intenta nuevamente.
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotFound;
